import StoreButtons from '../components/StoreButtons';

export default function Home() {
  return (
    <main>

      {/* ── Hero ─────────────────────────────────── */}
      <section className="hero" id="download">
        <div className="hero-glow" aria-hidden="true" />
        <div className="hero-glow-2" aria-hidden="true" />
        <div className="container">
          <div className="hero-content">
            <div className="hero-eyebrow">
              <span className="hero-eyebrow-dot" aria-hidden="true" />
              Guest Mode Available — No Account Required
            </div>
            <h1 className="hero-headline">
              Quit <em>Gooning</em>.<br />
              Break Free from<br />
              Porn Addiction.
            </h1>
            <p className="hero-sub">
              The private porn addiction recovery app with a built-in guest mode —
              no sign-up, no cloud, no tracking. Or create an account to sync across
              devices. Your recovery, your rules. Free on iOS and Android.
            </p>
            <StoreButtons />
            <div className="hero-stats" aria-label="App statistics">
              <div className="hero-stat">
                <strong>4.8★</strong> App Rating
              </div>
              <div className="hero-stat-sep" aria-hidden="true" />
              <div className="hero-stat">
                <strong>100%</strong> Private
              </div>
              <div className="hero-stat-sep" aria-hidden="true" />
              <div className="hero-stat">
                <strong>iOS</strong> &amp; Android
              </div>
              <div className="hero-stat-sep" aria-hidden="true" />
              <div className="hero-stat">
                <strong>Free</strong> to Start
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Answer Capsule (AI/SEO) ──────────────── */}
      <section className="answer-capsule">
        <div className="container">
          <div className="answer-inner">
            <h2 className="answer-headline">What Is Quit Gooning?</h2>
            <p className="answer-text">
              <strong>Quit Gooning is a free app designed to help you quit porn addiction,
              stop gooning, and overcome compulsive pornography habits.</strong> It works as a
              private streak tracker with daily recovery tasks, a panic button for urges,
              and a structured building phase plan. Use it in <strong>guest mode</strong> —
              fully offline with no account needed — or create an account to sync progress
              across devices. Available on both iOS and Android.
            </p>
          </div>
        </div>
      </section>

      {/* ── How It Works ─────────────────────────── */}
      <section className="how-it-works">
        <div className="container">
          <div className="section-badge">Getting Started</div>
          <h2 className="section-heading">Three Steps to Start Your Recovery</h2>
          <p className="section-sub">
            Use guest mode and skip sign-up entirely, or create an account — either way,
            you're on day one in under a minute.
          </p>
          <div className="steps-grid">
            <div className="step">
              <div className="step-num">1</div>
              <div className="step-icon" aria-hidden="true">📲</div>
              <h3 className="step-title">Download — Guest or Account</h3>
              <p className="step-desc">Install on iOS or Android. Continue as a guest with no sign-up, or create an account to sync across devices. Your choice.</p>
            </div>
            <div className="step">
              <div className="step-num">2</div>
              <div className="step-icon" aria-hidden="true">📅</div>
              <h3 className="step-title">Set Your Start Date</h3>
              <p className="step-desc">Log your first porn-free day and activate your daily building phase tasks — morning routine, exercise, meditation.</p>
            </div>
            <div className="step">
              <div className="step-num">3</div>
              <div className="step-icon" aria-hidden="true">🔥</div>
              <h3 className="step-title">Track, Beat Urges, Rebuild</h3>
              <p className="step-desc">Watch your streak grow. When urges hit, tap the panic button. The app stays with you — privately, offline, always.</p>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* ── Value Proposition ────────────────────── */}
      <section className="values">
        <div className="container">
          <div className="section-badge">Why Quit Gooning</div>
          <h2 className="section-heading">Built Different from Every Other Recovery App</h2>
          <p className="section-sub">
            No data leaves your device. No accounts. No judgment. Just a calm, focused
            tool for your recovery.
          </p>
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon-wrap" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgba(16,185,129,0.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0110 0v4" />
                </svg>
              </div>
              <h3 className="value-title">Guest Mode — 100% Private</h3>
              <p className="value-desc">Skip sign-up and use guest mode: fully offline, no cloud, no tracking, no ads. Or create an account to sync across devices — still no ads, ever.</p>
            </div>
            <div className="value-card">
              <div className="value-icon-wrap" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgba(16,185,129,0.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                </svg>
              </div>
              <h3 className="value-title">Streak &amp; Progress Tracking</h3>
              <p className="value-desc">A calm day counter, 14-day heatmap, and detailed progress stats that show your growth — not your shame.</p>
            </div>
            <div className="value-card">
              <div className="value-icon-wrap" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="rgba(16,185,129,0.9)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </div>
              <h3 className="value-title">Structured Daily Recovery</h3>
              <p className="value-desc">Morning routine, exercise, meditation — organized into building phases that rewire your habits one day at a time.</p>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* ── Features ─────────────────────────────── */}
      <section className="features">
        <div className="container">
          <div className="section-badge">Features</div>
          <h2 className="section-heading">Porn Addiction Recovery App Features</h2>
          <p className="section-sub">
            Every feature is designed for one purpose: helping you quit porn for good.
          </p>
          <div className="features-grid">
            <div className="feature-item">
              <span className="feature-icon" aria-hidden="true">⏱️</span>
              <div>
                <h3 className="feature-title">Day Counter &amp; Streak Tracker</h3>
                <p className="feature-desc">Watch your porn-free streak grow day by day with a large, motivating counter tracking days, hours, minutes, and seconds.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon" aria-hidden="true">🚨</span>
              <div>
                <h3 className="feature-title">Panic Button for Urges</h3>
                <p className="feature-desc">When urges hit hardest, tap the panic button for immediate in-app support. Designed to get you through your weakest moments.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon" aria-hidden="true">✅</span>
              <div>
                <h3 className="feature-title">Building Phase Plan</h3>
                <p className="feature-desc">Daily tasks organized into recovery phases — physical health, mindfulness, sleep habits — to rebuild discipline from scratch.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon" aria-hidden="true">📊</span>
              <div>
                <h3 className="feature-title">14-Day Progress Heatmap</h3>
                <p className="feature-desc">Visualize your last 14 days at a glance. Spot your patterns and stay motivated with a clear picture of your recovery journey.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon" aria-hidden="true">🔒</span>
              <div>
                <h3 className="feature-title">Guest Mode — No Sign-Up Needed</h3>
                <p className="feature-desc">Use the app instantly as a guest — no email, no registration, no personal data. Or sign in to sync progress across your iPhone and Android devices.</p>
              </div>
            </div>
            <div className="feature-item">
              <span className="feature-icon" aria-hidden="true">📡</span>
              <div>
                <h3 className="feature-title">Fully Offline — Always</h3>
                <p className="feature-desc">No internet needed — ever. Your recovery data never leaves your phone. Every feature works without any network connection.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── App Preview ──────────────────────────── */}
      <section className="preview">
        <div className="container">
          <div className="section-badge">App Preview</div>
          <h2 className="section-heading">See the Quit Gooning App in Action</h2>
          <p className="section-sub">
            Calm, focused design — built to stay out of your way and keep you on track.
          </p>
          <div className="preview-wrapper">
            <div className="preview-glow" aria-hidden="true" />
            <div className="preview-phone">
              <img
                src="/ss1.png"
                alt="Quit Gooning app — porn-free streak counter showing 45 days, 14-day progress heatmap, and daily recovery tasks including morning routine and exercise on iPhone"
                className="preview-screenshot"
                width="232"
                height="502"
                loading="eager"
              />
            </div>
          </div>
          <p className="preview-caption">Your recovery. Your phone. Nobody else's business.</p>
        </div>
      </section>

      <div className="section-divider" />

      {/* ── Testimonials ─────────────────────────── */}
      <section className="testimonials">
        <div className="container">
          <div className="section-badge">Reviews</div>
          <h2 className="section-heading">Why People Trust Quit Gooning</h2>
          <p className="section-sub">
            From the App Store and Google Play — real users on their recovery journey.
          </p>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-stars" aria-label="5 stars">★★★★★</div>
              <p className="testimonial-text">
                "Day 47 and still going. The panic button has saved me more times than I
                can count. This is the only app that actually respects my privacy."
              </p>
              <span className="testimonial-author">— App Store User</span>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars" aria-label="5 stars">★★★★★</div>
              <p className="testimonial-text">
                "Finally an app that doesn't make me sign up or connect to the cloud. My
                recovery is my business. The building phase tasks genuinely helped me replace
                the habit with better ones."
              </p>
              <span className="testimonial-author">— Google Play User</span>
            </div>
            <div className="testimonial-card">
              <div className="testimonial-stars" aria-label="5 stars">★★★★★</div>
              <p className="testimonial-text">
                "I've tried 4 other nofap apps. This is the only one that works offline and
                doesn't require an account. The 14-day heatmap keeps me motivated every
                single morning."
              </p>
              <span className="testimonial-author">— Android User</span>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* ── Who Is This For ──────────────────────── */}
      <section className="who-section">
        <div className="container">
          <div className="section-badge">Who It's For</div>
          <h2 className="section-heading">Who Uses This Porn Recovery App?</h2>
          <p className="section-sub">
            Whether you're on day one or day one hundred — this app meets you where you are.
          </p>
          <div className="who-grid">
            <div className="who-card">
              <h3>People Who Want to Quit Porn</h3>
              <p>Whether you've been watching for years or want to stop before it escalates, this app gives you a private tracker and daily structure to break the habit.</p>
            </div>
            <div className="who-card">
              <h3>People Struggling with Gooning</h3>
              <p>Gooning — the compulsive, trance-like consumption of pornography — hijacks your dopamine system. Quit Gooning helps you break the cycle with structured daily recovery tasks.</p>
            </div>
            <div className="who-card">
              <h3>NoFap &amp; Porn-Free Community</h3>
              <p>If you're on a NoFap journey or committed to going porn-free, this app is a fully private streak tracker that doesn't share your data with anyone — including us.</p>
            </div>
            <div className="who-card">
              <h3>Anyone Doing a Dopamine Detox</h3>
              <p>Porn overstimulates your brain's reward system. Quit Gooning helps you reset by replacing compulsive habits with healthy daily routines and tracking your recovery quietly.</p>
            </div>
          </div>
        </div>
      </section>

      <div className="section-divider" />

      {/* ── Pricing ──────────────────────────────── */}
      <section className="pricing">
        <div className="container">
          <div className="section-badge">Pricing</div>
          <h2 className="section-heading">Quit Porn Addiction App Pricing</h2>
          <p className="section-sub">Start free today. Upgrade for lifetime access when you're ready.</p>
          <div className="pricing-grid">
            <div className="pricing-card">
              <h3 className="pricing-name">Weekly</h3>
              <p className="pricing-price">$4.99<span>/wk</span></p>
              <ul className="pricing-features">
                <li>Full streak tracker</li>
                <li>Daily recovery tasks</li>
                <li>Panic button</li>
                <li>14-day heatmap</li>
                <li>Cancel anytime</li>
              </ul>
            </div>
            <div className="pricing-card pricing-popular">
              <span className="pricing-badge">Best Value</span>
              <h3 className="pricing-name">Yearly</h3>
              <p className="pricing-price">$24.99<span>/yr</span></p>
              <ul className="pricing-features">
                <li>Everything in Weekly</li>
                <li>Save 90% vs weekly</li>
                <li>Building phase plans</li>
                <li>Progress statistics</li>
                <li>Priority support</li>
              </ul>
            </div>
            <div className="pricing-card">
              <h3 className="pricing-name">Lifetime</h3>
              <p className="pricing-price">$39.99<span> once</span></p>
              <ul className="pricing-features">
                <li>Everything, forever</li>
                <li>One-time payment</li>
                <li>All future features</li>
                <li>No recurring charges</li>
                <li>Best for long-term</li>
              </ul>
            </div>
          </div>
          <p className="pricing-note">
            Cancel anytime through your App Store or Google Play subscription settings.
            Guest mode is always free with core tracking features.
          </p>
        </div>
      </section>

      <div className="section-divider" />

      {/* ── FAQ ──────────────────────────────────── */}
      <section className="faq-section">
        <div className="container">
          <div className="section-badge">FAQ</div>
          <h2 className="section-heading">Porn Addiction Recovery — Common Questions</h2>
          <p className="section-sub">
            Everything you need to know about Quit Gooning and quitting porn addiction.
          </p>
          <div className="faq-list">
            <details className="faq-item">
              <summary className="faq-question">What is gooning and why is it harmful?</summary>
              <p className="faq-answer">
                Gooning is a compulsive behavior involving extended, trance-like pornography consumption
                that hijacks the brain's dopamine reward system. It can lead to escalating content
                consumption, reduced interest in real-life activities, difficulty with real relationships,
                brain fog, and an inability to focus. Quit Gooning helps you break this cycle through
                structured daily tasks and streak tracking.
              </p>
            </details>
            <details className="faq-item">
              <summary className="faq-question">What is the best app to quit gooning and porn addiction?</summary>
              <p className="faq-answer">
                Quit Gooning is one of the best apps to quit gooning and overcome porn addiction. It
                provides a private, offline streak tracker, daily recovery tasks, a panic button for
                urges, and a structured building phase plan. Unlike other apps, Quit Gooning requires
                no accounts, no cloud storage, and no internet connection — all data stays on your device.
              </p>
            </details>
            <details className="faq-item">
              <summary className="faq-question">How is Quit Gooning different from other NoFap apps?</summary>
              <p className="faq-answer">
                Quit Gooning stands out because it is completely private (no accounts or sign-ups),
                fully offline (no cloud or internet required), has no ads or tracking, includes a
                structured daily task system with a building phase plan, and is designed with a calm,
                non-judgmental approach. It's available on both iOS and Android starting at just
                $0.99/month — the most affordable option in its category.
              </p>
            </details>
            <details className="faq-item">
              <summary className="faq-question">Is my data private in the Quit Gooning app?</summary>
              <p className="faq-answer">
                Yes — Quit Gooning is 100% private and offline. There are no accounts, no cloud sync,
                and no analytics. All your data — including streaks, progress, and settings — is stored
                locally on your device. Nobody can see your data, not even the developers.
              </p>
            </details>
            <details className="faq-item">
              <summary className="faq-question">Can I use Quit Gooning on both iPhone and Android?</summary>
              <p className="faq-answer">
                Yes — Quit Gooning is available on both iOS (iPhone, iOS 14+) and Android (8.0+).
                In guest mode your progress is stored locally on your device. Sign in with an
                account to sync your streak and history across both platforms.
              </p>
            </details>
            <details className="faq-item">
              <summary className="faq-question">Is Quit Gooning free to use?</summary>
              <p className="faq-answer">
                Guest mode is always free and gives access to core tracking features with no
                sign-up required. Premium plans unlock the full experience: Weekly at $4.99/week,
                Yearly at $24.99/year (best value — saves 90% vs weekly), or Lifetime access
                for a one-time payment of $39.99. Cancel anytime through your App Store or
                Google Play subscription settings — no surprise charges.
              </p>
            </details>
            <details className="faq-item">
              <summary className="faq-question">Does the app have a panic button for porn urges?</summary>
              <p className="faq-answer">
                Yes. Quit Gooning includes a dedicated panic button designed for when urges are
                strongest. Tapping it gives you immediate in-app support and tools to get through
                the moment without relapsing. It's one of the most-used features in the app.
              </p>
            </details>
            <details className="faq-item">
              <summary className="faq-question">What is the building phase plan?</summary>
              <p className="faq-answer">
                The building phase plan is a structured daily recovery system inside Quit Gooning.
                It organizes tasks — morning routine, exercise, meditation, cold showers — into
                progressive phases that help you build healthy habits to replace the porn habit.
                It's based on behavioral psychology principles for sustainable habit change.
              </p>
            </details>
          </div>
        </div>
      </section>

      {/* ── Final CTA ────────────────────────────── */}
      <section className="secondary-cta">
        <div className="container">
          <div className="cta-inner">
            <h2 className="secondary-headline">
              Ready to Quit Porn<br />and Take Back Control?
            </h2>
            <p className="secondary-sub">
              Download Quit Gooning — use guest mode instantly with no sign-up, or create
              an account to sync across devices. Your recovery starts now. Free on iOS and Android.
            </p>
            <StoreButtons />
          </div>
        </div>
      </section>

    </main>
  );
}
